import React from 'react';
import { AiOutlineClose } from "react-icons/ai";
import Modal from 'react-modal';
import moment from 'moment';

Modal.setAppElement('#root');

function PreviewBorradorInforme({ preview, abierto, onCerrar, onAplicar, cargando }) {

    const valorNumero = (numero) => new Intl.NumberFormat().format(numero);

    if (!preview) {
        return null;
    }

    const { origen, borrador, items, alertas, totales } = preview;
    const alertasPorNombre = {};
    (alertas || []).forEach((alerta) => {
        alertasPorNombre[alerta.nombre] = alerta;
    });

    const joinParrafos = (val) => {
        if (Array.isArray(val)) {
            return val.filter(Boolean).join('\n');
        }
        return val || '';
    };

    const resumenTexto = (texto) => {
        if (!texto) return '-';
        return texto.length > 220 ? `${texto.slice(0, 220)}…` : texto;
    };

    const fechaOrigen = origen?.fecha
        ? moment(origen.fecha).format('DD/MM/YYYY')
        : '-';

    const filaCambio = (item) => {
        const historico = Number(item.valorHistorico);
        const actual = Number(item.valorActual ?? item.valor);
        return historico !== actual;
    };

    return (
        <Modal
            isOpen={abierto}
            onRequestClose={onCerrar}
            className="Modal Modal--ancho"
            contentLabel="Previsualización del borrador"
            overlayClassName="Overlay"
        >
            <p onClick={onCerrar} className="modal__close"><AiOutlineClose/></p>
            <h2 className="modal__titulo">Previsualizar borrador</h2>
            <p className="modal__subtitulo">
                Informe OTIN {origen?.otin} — {origen?.equipo} ({fechaOrigen})
            </p>

            <div className="similar-preview">
                {
                    (alertas || []).length > 0 ? (
                        <p className="similar-aviso">
                            {alertas.length} ítems cambiaron de precio desde el informe original. Se aplicaron los valores actuales del catálogo.
                        </p>
                    ) : null
                }

                <div className="similar-preview__textos">
                    <div>
                        <h3>Falla</h3>
                        <p>{resumenTexto(joinParrafos(borrador?.fallaText) || borrador?.falla)}</p>
                    </div>
                    <div>
                        <h3>Conclusión</h3>
                        <p>{resumenTexto(joinParrafos(borrador?.conclusion))}</p>
                    </div>
                    <div>
                        <h3>Recomendación</h3>
                        <p>{resumenTexto(joinParrafos(borrador?.recomendacion))}</p>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr className="table__head">
                                <th scope="col">Nombre</th>
                                <th scope="col">Descripción</th>
                                <th scope="col">Cant.</th>
                                <th scope="col">Precio anterior</th>
                                <th scope="col">Precio actual</th>
                                <th scope="col">Variación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (items || []).length > 0 ? (
                                    items.map((item, index) => {
                                        const cambio = filaCambio(item);
                                        const alerta = alertasPorNombre[item.nombre];
                                        const porcentaje = alerta?.porcentaje;
                                        const subio = Number(item.valorActual ?? item.valor) > Number(item.valorHistorico);
                                        const claseFila = cambio
                                            ? (subio ? 'similar-precio--subio' : 'similar-precio--bajo')
                                            : '';

                                        return (
                                            <tr className={`table__tr ${claseFila}`} key={item.cotizacionItemId || index}>
                                                <td>{item.nombre}</td>
                                                <td>{item.descripcion || '-'}</td>
                                                <td>{item.cantidad}</td>
                                                <td>${valorNumero(item.valorHistorico)}</td>
                                                <td>${valorNumero(item.valorActual ?? item.valor)}</td>
                                                <td>
                                                    {
                                                        cambio && porcentaje != null
                                                            ? `${subio ? '+' : ''}${porcentaje}%`
                                                            : '-'
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={6}><p className="mensaje-vacio">Este informe no tiene ítems de cotización</p></td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>

                <div className="similar-totales">
                    <p>Total histórico: <span>${valorNumero(totales?.historico || 0)}</span></p>
                    <p>Total actual: <span>${valorNumero(totales?.actual || 0)}</span></p>
                </div>
            </div>

            <div className="opciones">
                <div className="enviar">
                    <button type="button" className="btn-new btn-return" onClick={onCerrar} disabled={cargando}>
                        Cancelar
                    </button>
                </div>
                <div className="enviar">
                    <button type="button" className="btn-new btn-success-new" onClick={onAplicar} disabled={cargando}>
                        Aplicar al informe
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default PreviewBorradorInforme;
